export const minValueForFreeDelivery = 499;
export const deliveryCharge = 20;
export const minValueForOrderToProceed = 50;
export const EstoreAdminToken =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoidmVuZG9yIiwidXNlcklkIjoiNjc1ODc3YTk5ODQzNmRlODQyNzg5OWQ4IiwiaWF0IjoxNzQ1ODI3NTUwfQ.IumnzrbLjTEg2w074accS1UPrMkgfw1oq08dJr-BGY8";
